import React, { useEffect, useState, useMemo, useRef } from 'react';
import './index.scss';
import { getSearchTennisAPI } from '../../apis/searchTennis';
import { List, Card, Select, DatePicker, Tag } from 'antd';
import { isHoliday } from 'japanese-holidays';
import { Layout, Menu } from 'antd';
import Loading from './loader';
import { getTokyoResultAPI, saveTokyoResultAPI } from '../../apis/searchTennis';
import TennisUser from '../tennisUser';
import loginImage from '../../assets/login.jpg';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import HeaderLanguageSwitch from '../HeaderLanguageSwitch';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

// 判断是否为周末或日本祝日
function isWeekendOrHoliday(dateStr: string) {
    const date = new Date(dateStr);
    const weekday = date.getDay();
    if (weekday === 0 || weekday === 6) return true;
    return isHoliday(date);
}

// 计算距离
function getDistance(lat1: number, lng1: number, lat2: number, lng2: number) {
    const R = 6371000;
    const toRad = (value: number) => value * Math.PI / 180;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

const buildingList = [
    { id: '502000', name: '上千葉公園運動場' },
    { id: '501900', name: '小菅東スポーツ公園' },
    { id: '503200', name: 'にいじゅくみらい公園' },
    { id: '500700', name: '奥戸総スポテニス・野球場' },
    { id: '500100', name: '奥戸総スポ　体育館' },
    { id: '501800', name: '渋江公園' },
    { id: '500930', name: '水元総スポテニス' },
    { id: '503700', name: '東新小岩野球・テニス・会議室' },
    { id: '501700', name: '東金町テニスコート' }
];

const adachiBuildingList = [
    { id: '30000000', name: '宮元公園', lat: 35.7699778, lng: 139.8379793 },
    { id: '12500000', name: '平野運動場', lat: 35.784524, lng: 139.805144 },
    { id: '30500000', name: '江北公園', lat: 35.7859076, lng: 139.7512911 },
    { id: '12100000', name: '千住スポーツ公園', lat: 35.7444769, lng: 139.7950373 },
    { id: '11700000', name: '総合スポーツセンター', lat: 35.7927189, lng: 139.8131731 },
    { id: '30200000', name: '尾竹橋公園', lat: 35.7545953, lng: 139.7865371 },
    { id: '30100000', name: '竹の塚第六公園', lat: 35.7921269, lng: 139.794874 },
    { id: '30300000', name: '上沼田東公園', lat: 35.7799768, lng: 139.769133 }
];

const matsudoBuildingList = [
    { id: '2050', name: '栗ケ沢公園庭球場', lat: 35.813282, lng: 139.944329 },
    { id: '2090', name: '新松戸庭球場', lat: 35.818566, lng: 139.896497 },
    { id: '2070', name: '松戸中央公園庭球場', lat: 35.783299, lng: 139.902880 },
    { id: '2190', name: '東部スポーツパーク', lat: 35.766012, lng: 139.938720 },
    { id: '2060', name: '金ケ作公園庭球場', lat: 35.798981, lng: 139.954803 },
    { id: '2200', name: 'クリーンセンター内スポーツ施設', lat: 35.805609, lng: 139.987152 },
];

const tokyobuildingList = [
    { id: '1130', name: '東綾瀬公園', lat: 35.771248, lng: 139.832846 },
    { id: '1170', name: '汐入公園', lat: 35.736359, lng: 139.809339 },
    { id: '1090', name: '東白鬚公園', lat: 35.732549, lng: 139.813593 },
    { id: '1140', name: '舎人公園', lat: 35.798499, lng: 139.768344 },
    { id: '1050', name: '亀戸中央公園', lat: 35.700851, lng: 139.837853 },
    { id: '1160', name: '大島小松川公園', lat: 35.691661, lng: 139.847211 },
    { id: '1040', name: '猿江恩賜公園', lat: 35.691526, lng: 139.81921 },
    { id: '1150', name: '篠崎公園Ａ', lat: 35.715742, lng: 139.898041 },
    { id: '1060', name: '木場公園', lat: 35.677738, lng: 139.807658 },
    { id: '1000', name: '日比谷公園', lat: 35.675446, lng: 139.756331 },
    { id: '1100', name: '浮間公園', lat: 35.794531, lng: 139.692661 },
    { id: '1360', name: '有明テニスＣ人工芝コート', lat: 35.634612, lng: 139.788781 },
    { id: '1010', name: '芝公園', lat: 35.653985, lng: 139.747373 },
    { id: '1110', name: '城北中央公園', lat: 35.756587, lng: 139.674937 },
    { id: '1120', name: '赤塚公園', lat: 35.785281, lng: 139.65699 },
    { id: '1315', name: '大井ふ頭海浜公園Ｂ', lat: 35.595086, lng: 139.751785 },
    { id: '1190', name: '光が丘公園', lat: 35.765218, lng: 139.631018 },
    { id: '1180', name: '善福寺川緑地', lat: 35.691247, lng: 139.632497 },
    { id: '1205', name: '石神井公園Ｂ', lat: 35.737526, lng: 139.602609 },
    { id: '1175', name: '高井戸公園', lat: 35.681464, lng: 139.603593 },
    { id: '1070', name: '祖師谷公園', lat: 35.655672, lng: 139.59972 },
    { id: '1220', name: '井の頭恩賜公園', lat: 35.697365, lng: 139.570533 },
    { id: '1230', name: '武蔵野中央公園', lat: 35.718743, lng: 139.556974 },
    { id: '1240', name: '小金井公園', lat: 35.714889, lng: 139.528141 },
    { id: '1260', name: '野川公園', lat: 35.680798, lng: 139.523121 },
    { id: '1270', name: '府中の森公園', lat: 35.677745, lng: 139.492277 },
    { id: '1280', name: '東大和南公園', lat: 35.0118489, lng: 135.7501042 }
];

const edogawaBuildingList = [
    { id: '1000000', name: '松江テニスコート', lat: 35.688221, lng: 139.866469 },
    { id: '2000000', name: '西葛西テニスコート', lat: 35.655305, lng: 139.863313 },
    { id: '3000000', name: '小岩テニスコート', lat: 35.746474, lng: 139.887400 },
    { id: '4000000', name: '谷河内テニスコート', lat: 35.701381, lng: 139.898779 },
    { id: '5000000', name: 'スポーツランド', lat: 35.698436, lng: 139.917021 },
    { id: '6000000', name: '水辺のスポーツガーデン', lat: 35.692893, lng: 139.914141 }
];

const { Header } = Layout;
const { Option } = Select;
const { RangePicker } = DatePicker;

export default function SearchTennis() {
    const { t } = useTranslation();
    const [isHovered, setIsHovered] = useState(false); // 记录鼠标是否悬浮在目标上
    const [isTooltipHovered, setIsTooltipHovered] = useState(false);
    const [tennisData, setTennisData] = useState<any>(null);
    const [matsudoData, setMatsudoData] = useState<any[]>([]);
    const [edogawaData, setEdogawaData] = useState<any[]>([]);
    const [katsushikaData, setKatsushikaData] = useState<any[]>([]);
    const [tokyoData, setTokyoData] = useState<any[]>([]);
    const [geo, setGeo] = useState<{ longitude: string, latitude: string } | null>(null);
    const [loading, setLoading] = useState(false);
    const [tokyoLoading, setTokyoLoading] = useState(false);
    const [katsushikaFinished, setKatsushikaFinished] = useState(false);
    const [tokyoFinished, setTokyoFinished] = useState(false);
    const [useRedisResult, setUseRedisResult] = useState(null as boolean | null);
    const [redisTennisList, setRedisTennisList] = useState<any[]>([]);
    const [dots, setDots] = useState<string>('');
    const [redisRetryIndex, setRedisRetryIndex] = useState(0);
    const [filter, setFilter] = useState<string>('all');
    const [selectedStart, setSelectedStart] = useState<string | null>(null);
    const [selectedEnd, setSelectedEnd] = useState<string | null>(null);
    const tooltipDisableTimerRef = useRef<NodeJS.Timeout | null>(null);
    const [tooltipDisabledUntil, setTooltipDisabledUntil] = useState<number | null>(null);

    useEffect(() => {
        return () => {
            if (tooltipDisableTimerRef.current) {
                clearTimeout(tooltipDisableTimerRef.current);
            }
        };
    }, []);

    // 当 tooltip 的内容被 hover 时调用：隐藏 tooltip 并在 5s 后恢复
    const handleTooltipOverlayHover = () => {
        const until = Date.now() + 5000;
        setTooltipDisabledUntil(until);
        if (tooltipDisableTimerRef.current) {
            clearTimeout(tooltipDisableTimerRef.current);
        }
        tooltipDisableTimerRef.current = setTimeout(() => {
            setTooltipDisabledUntil(null);
            tooltipDisableTimerRef.current = null;
        }, 5000);
    };

    const isTooltipDisabled = tooltipDisabledUntil !== null && Date.now() < tooltipDisabledUntil;

    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    const todayStr = dayjs().format('YYYY-MM-DD');

    // 根据场馆名判断所属区/市
    function getDistrictByName(name: string) {
        if (buildingList.some(b => b.name === name)) return '葛飾区';
        if (adachiBuildingList.some(b => b.name === name)) return '足立区';
        if (matsudoBuildingList.some(b => b.name === name)) return '松戸市';
        if (edogawaBuildingList.some(b => b.name === name)) return '江戸川区';
        if (tokyobuildingList.some(b => b.name === name)) return '都立公園';
        return 'その他';
    }

    const toDate = (v: any) => {
        // 把 moment/dayjs 等转换为原生 Date；若 v 已是 Date，直接返回
        if (!v) return null;
        if (typeof v.toDate === 'function') return v.toDate();
        if (v instanceof Date) return v;
        return new Date(v);
    };

    const navigate = useNavigate();

    useEffect(() => {
        let timer: NodeJS.Timeout | null = null;
        if (loading) {
            timer = setInterval(() => {
                setDots(prev => (prev.length < 3 ? prev + '.' : ''));
            }, 500);
        } else {
            setDots('');
        }
        return () => {
            if (timer) clearInterval(timer);
        };
    }, [loading]);

    // 初始时尝试获取 Redis 结果
    useEffect(() => {
        (async () => {
            try {
                console.log('尝试从 Redis 获取结果...');
                const res = await getTokyoResultAPI();
                console.log('Redis 返回结果:', res);
                if (res && res.result && res.result.timestamp) {
                    const today = new Date();
                    const redisDate = new Date(res.result.timestamp);
                    if (
                        today.getFullYear() === redisDate.getFullYear() &&
                        today.getMonth() === redisDate.getMonth() &&
                        today.getDate() === redisDate.getDate()
                    ) {
                        // 时间戳是今天，直接用 Redis 结果
                        setLoading(false);
                        setUseRedisResult(true);
                        // tennisList 由 redis 数据生成
                        setTennisData(null);
                        setEdogawaData([]);
                        setKatsushikaData([]);
                        setTokyoData([]);
                        // 直接用 redis 数据渲染
                        setTokyoFinished(true);
                        setRedisTennisList(res.result.data || []);
                    }
                }
                else {
                    setUseRedisResult(false);
                }
            } catch (error) {
                // Redis无数据或出错，继续正常流程
            }
        })();
    }, []);

    // useEffect(() => {
    //     // 只在用redis结果且有geo时执行
    //     if (useRedisResult && redisTennisList.length > 0 && geo) {
    //         // 找到所有 days 为空且 name 在 tokyobuildingList 的场馆
    //         const emptyList = redisTennisList
    //             .map((item, idx) => ({
    //                 ...item,
    //                 idx,
    //                 exists: tokyobuildingList.some(b => b.name === item.name),
    //                 isEmpty: !item.days || Object.keys(item.days).length === 0
    //             }))
    //             .filter(item => item.isEmpty && item.exists);

    //         if (redisRetryIndex < emptyList.length) {
    //             const item = emptyList[redisRetryIndex];
    //             const building = tokyobuildingList.find(b => b.name === item.name);
    //             console.log(`正在用 Redis 重查 ${item.name}，索引 ${redisRetryIndex + 1}/${emptyList.length}`);
    //             if (building) {
    //                 (async () => {
    //                     try {
    //                         const res = await getSearchTennisAPI(
    //                             geo.longitude,
    //                             geo.latitude,
    //                             false,
    //                             "tokyo",
    //                             undefined,
    //                             building.id
    //                         );
    //                         const info = res.TennisList[item.name];
    //                         const updatedList = [...redisTennisList];
    //                         if (info && info.days && Object.keys(info.days).length > 0) {
    //                             updatedList[item.idx].days = info.days;
    //                             setRedisTennisList(updatedList);
    //                             await saveTokyoResultAPI(updatedList, Date.now());
    //                         }
    //                     } catch (error) {
    //                         console.error(`单独重查 ${item.name} 失败:`, error);
    //                     } finally {
    //                         setRedisRetryIndex(prev => prev + 1); // 无论成功失败都递增
    //                     }
    //                 })();
    //             } else {
    //                 // 没有building也递增
    //                 setRedisRetryIndex(prev => prev + 1);
    //             }
    //         }
    //     }
    // }, [useRedisResult, redisTennisList, geo, redisRetryIndex]);

    useEffect(() => {
        if (useRedisResult) return;
        if (navigator.geolocation) {
            setLoading(true);
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    setGeo({ longitude: longitude?.toString(), latitude: latitude?.toString() });
                    try {
                        const res = await getSearchTennisAPI(longitude?.toString(), latitude?.toString(), true);
                        // 检查 days 是否为空，如果为空则重试一次
                        let tennisListObj = res.TennisList;
                        let needRetry = false;
                        for (const [name, info] of Object.entries(tennisListObj)) {
                            if (!(info as any)?.days || Object.keys((info as any)?.days ?? {}).length === 0) {
                                needRetry = true;
                                break;
                            }
                        }
                        if (needRetry) {
                            const retryRes = await getSearchTennisAPI(longitude?.toString(), latitude?.toString(), true);
                            tennisListObj = retryRes.TennisList;
                        }
                        setTennisData(tennisListObj);
                    } catch (error) {
                        console.error('网球场馆搜索API调用失败:', error);
                    } finally {
                        setLoading(false);
                    }
                },
                async (error) => {
                    console.error('获取位置信息失败:', error.message);
                    // 使用默认地理位置（东京）
                    console.warn('无法获取地理位置，使用默认位置');
                    const defaultGeo = { longitude: '139.827304', latitude: '35.767462' };
                    setGeo(defaultGeo);

                    try {
                        // 直接用默认坐标去调用一次首次 API
                        const res = await getSearchTennisAPI(
                            defaultGeo.longitude,
                            defaultGeo.latitude,
                            true
                        );
                        let tennisListObj = res.TennisList;
                        let needRetry = false;
                        for (const [name, info] of Object.entries(tennisListObj)) {
                            if (!(info as any)?.days || Object.keys((info as any)?.days ?? {}).length === 0) {
                                needRetry = true;
                                break;
                            }
                        }
                        if (needRetry) {
                            const retryRes = await getSearchTennisAPI(
                                defaultGeo.longitude,
                                defaultGeo.latitude,
                                true
                            );
                            tennisListObj = retryRes.TennisList;
                        }
                        setTennisData(tennisListObj);
                    } catch (e) {
                        console.error('使用默认位置调用网球场馆搜索API失败:', e);
                    } finally {
                        setLoading(false);
                    }
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0
                }
            );
        } else {
            // 浏览器不支持 geolocation 时，直接用默认位置
            console.warn('浏览器不支持地理位置，使用默认位置');
            const defaultGeo = { longitude: '139.827304', latitude: '35.767462' };
            setGeo(defaultGeo);
            (async () => {
                setLoading(true);
                try {
                    const res = await getSearchTennisAPI(
                        defaultGeo.longitude,
                        defaultGeo.latitude,
                        true
                    );
                    setTennisData(res.TennisList);
                } catch (e) {
                    console.error('使用默认位置调用网球场馆搜索API失败:', e);
                } finally {
                    setLoading(false);
                }
            })();
        }
    }, [useRedisResult]);

    useEffect(() => {
        if (useRedisResult) return;
        if (tennisData && Object.keys(tennisData).length > 0 && geo) {
            (async () => {
                setLoading(true);
                try {
                    const res = await getSearchTennisAPI(
                        geo.longitude,
                        geo.latitude,
                        false,
                        "edogawa"
                    );
                    if (res && res.TennisList) {
                        // 转换为数组结构
                        const arr = Object.entries(res.TennisList).map(([name, info]: any) => ({
                            name,
                            lat: info.lat,
                            lng: info.lng,
                            days: info.days
                        }));
                        setEdogawaData(arr);
                    }
                } catch (error) {
                    console.error('江户网球场馆搜索API调用失败:', error);
                } finally {
                    setLoading(false);
                }
            })();
        }
    }, [geo, useRedisResult, tennisData]);

    useEffect(() => {
        if (useRedisResult) return;
        if (edogawaData && Object.keys(edogawaData).length > 0 && geo) {
            (async () => {
                setLoading(true);
                try {
                    const res = await getSearchTennisAPI(
                        geo.longitude,
                        geo.latitude,
                        false,
                        "matsudo"
                    );
                    if (res && res.TennisList) {
                        // 转换为数组结构
                        const arr = Object.entries(res.TennisList).map(([name, info]: any) => ({
                            name,
                            lat: info.lat,
                            lng: info.lng,
                            days: info.days
                        }));
                        setMatsudoData(arr);
                    }
                } catch (error) {
                    console.error('松戸网球场馆搜索API调用失败:', error);
                } finally {
                    setLoading(false);
                }
            })();
        }
    }, [geo, useRedisResult, edogawaData]);


    // 第二次请求：依赖 tennisData 和 geo，只有第一次请求成功后才发起
    useEffect(() => {
        if (useRedisResult) return;
        if (matsudoData && Object.keys(matsudoData).length > 0 && geo) {
            (async () => {
                setLoading(true);
                for (const building of buildingList) {
                    try {
                        const res = await getSearchTennisAPI(
                            geo.longitude,
                            geo.latitude,
                            false,
                            "katsushika",
                            building.id
                        );
                        if (res && res.TennisList) {
                            const newList = Object.entries(res.TennisList).map(([name, info]: any) => ({
                                name,
                                lat: info.lat,
                                lng: info.lng,
                                days: info.days
                            }));

                            // 检查days是否为空，如果为空则重试一次
                            for (let item of newList) {
                                if (!item.days || Object.keys(item.days).length === 0) {
                                    const retryRes = await getSearchTennisAPI(
                                        geo.longitude,
                                        geo.latitude,
                                        false,
                                        "katsushika",
                                        building.id
                                    );
                                    const retryInfo = retryRes.TennisList[item.name];
                                    if (retryInfo && retryInfo.days && Object.keys(retryInfo.days).length > 0) {
                                        item.days = retryInfo.days;
                                    }
                                    // 如果还是空，直接添加
                                }
                            }

                            // 分次添加（去重）
                            setKatsushikaData(prev => {
                                const nameSet = new Set(prev.map(item => item.name));
                                const filtered = newList.filter(item => !nameSet.has(item.name));
                                return [...prev, ...filtered];
                            });
                        }
                    } catch (error) {
                        console.error(`building_id ${building.id} 搜索API调用失败:`, error);
                    }
                }
                setLoading(false);
                setKatsushikaFinished(true);
            })();
        }
    }, [matsudoData]);

    // katsushika全部完成后，分批请求tokyo
    useEffect(() => {
        if (useRedisResult) return;
        if (katsushikaFinished && geo) {
            (async () => {
                setTokyoLoading(true);
                for (const building of tokyobuildingList) {
                    try {
                        const res = await getSearchTennisAPI(
                            geo.longitude,
                            geo.latitude,
                            false,
                            "tokyo",
                            undefined,
                            building.id
                        );
                        if (res && res.TennisList) {
                            let newList = Object.entries(res.TennisList).map(([name, info]: any) => ({
                                name,
                                lat: info.lat,
                                lng: info.lng,
                                days: info.days
                            }));

                            // 检查days是否为空，如果为空则重试一次
                            for (let item of newList) {
                                if (!item.days || Object.keys(item.days).length === 0) {
                                    const retryRes = await getSearchTennisAPI(
                                        geo.longitude,
                                        geo.latitude,
                                        false,
                                        "tokyo",
                                        undefined,
                                        building.id
                                    );
                                    const retryInfo = retryRes.TennisList[item.name];
                                    if (retryInfo && retryInfo.days && Object.keys(retryInfo.days).length > 0) {
                                        item.days = retryInfo.days;
                                    }
                                }
                            }

                            setTokyoData(prev => {
                                const nameSet = new Set(prev.map(item => item.name));
                                const filtered = newList.filter(item => !nameSet.has(item.name));
                                return [...prev, ...filtered];
                            });
                        }
                    } catch (error) {
                        console.error(`tokyo_building_id ${building.id} 搜索API调用失败:`, error);
                    }
                }
                setTokyoLoading(false);
                setTokyoFinished(true);
            })();
        }
    }, [katsushikaFinished, geo]);


    // 将对象转为数组，方便渲染
    const tennisList = useMemo(() => {
        if (useRedisResult) {
            return redisTennisList;
        }
        let list: any[] = [];
        if (tennisData && geo) {
            list = Object.entries(tennisData).map(([name, info]: any) => ({
                name,
                lat: info.lat,
                lng: info.lng,
                days: info.days,
                distance: getDistance(
                    Number(geo.latitude),
                    Number(geo.longitude),
                    info.lat,
                    info.lng
                )
            }));
        } else if (tennisData) {
            // 没有geo时不计算距离、不排序
            list = Object.entries(tennisData).map(([name, info]: any) => ({
                name,
                lat: info.lat,
                lng: info.lng,
                days: info.days
            }));
        }

        // 合并 edogawaData
        if (edogawaData.length > 0 && geo) {
            const nameSet = new Set(list.map(item => item.name));
            edogawaData.forEach(item => {
                if (!nameSet.has(item.name)) {
                    list.push({
                        ...item,
                        distance: getDistance(
                            Number(geo.latitude),
                            Number(geo.longitude),
                            item.lat,
                            item.lng
                        )
                    });
                }
            });
        } else if (edogawaData.length > 0) {
            const nameSet = new Set(list.map(item => item.name));
            edogawaData.forEach(item => {
                if (!nameSet.has(item.name)) {
                    list.push(item);
                }
            });
        }

        // 合并 matsudoData
        if (matsudoData.length > 0 && geo) {
            const nameSet = new Set(list.map(item => item.name));
            matsudoData.forEach(item => {
                if (!nameSet.has(item.name)) {
                    list.push({
                        ...item,
                        distance: getDistance(
                            Number(geo.latitude),
                            Number(geo.longitude),
                            item.lat,
                            item.lng
                        )
                    });
                }
            });
        } else if (matsudoData.length > 0) {
            const nameSet = new Set(list.map(item => item.name));
            matsudoData.forEach(item => {
                if (!nameSet.has(item.name)) {
                    list.push(item);
                }
            });
        }
        if (katsushikaData.length > 0 && geo) {
            const nameSet = new Set(list.map(item => item.name));
            katsushikaData.forEach(item => {
                if (!nameSet.has(item.name)) {
                    list.push({
                        ...item,
                        distance: getDistance(
                            Number(geo.latitude),
                            Number(geo.longitude),
                            item.lat,
                            item.lng
                        )
                    });
                }
            });
        } else if (katsushikaData.length > 0) {
            // 没有geo时直接合并，不计算距离
            const nameSet = new Set(list.map(item => item.name));
            katsushikaData.forEach(item => {
                if (!nameSet.has(item.name)) {
                    list.push(item);
                }
            });
        }
        if (tokyoData.length > 0 && geo) {
            const nameSet = new Set(list.map(item => item.name));
            tokyoData.forEach(item => {
                if (!nameSet.has(item.name)) {
                    list.push({
                        ...item,
                        distance: getDistance(
                            Number(geo.latitude),
                            Number(geo.longitude),
                            item.lat,
                            item.lng
                        )
                    });
                }
            });
        } else if (tokyoData.length > 0) {
            const nameSet = new Set(list.map(item => item.name));
            tokyoData.forEach(item => {
                if (!nameSet.has(item.name)) {
                    list.push(item);
                }
            });
        }
        // 有geo时按距离排序，否则不排序
        if (geo) {
            return list.sort((a, b) => (a.distance ?? 0) - (b.distance ?? 0));
        }
        return list;
    }, [tennisData, edogawaData, matsudoData, katsushikaData, tokyoData]);

    const filteredTennisList = useMemo(() => {
        // if (filter === 'all') {
        //     return tennisList;
        // }
        return tennisList.filter(item => {
            // 按开始/结束日期（若有）过滤：只有在所选范围内有 days 才保留
            const allDates = Object.keys(item.days || {});
            if (selectedStart && selectedEnd) {
                // 范围过滤
                const hasInRange = allDates.some(d => d >= selectedStart && d <= selectedEnd);
                if (!hasInRange) return false;
            } else if (selectedStart) {
                // 只选开始日视为单日过滤
                if (!allDates.includes(selectedStart)) return false;
            } else if (selectedEnd) {
                // 只选结束日视为单日过滤
                if (!allDates.includes(selectedEnd)) return false;
            }
            const hasWeekend = Object.keys(item.days).some(date => isWeekendOrHoliday(date));
            if (filter === 'weekend') {
                return hasWeekend; // 只显示週末あり
            }
            if (filter === 'non-weekend') {
                return !hasWeekend; // 只显示週末なし
            }
            return true;
        });
    }, [tennisList, filter, selectedStart, selectedEnd]);

    // tokyo查询完成后，保存到 Redis
    useEffect(() => {
        if (tokyoFinished) {
            (async () => {
                try {
                    await saveTokyoResultAPI(tennisList, Date.now());
                } catch (error) {
                    console.error('保存到Redis失败', error);
                }
            })();
        }
    }, [tokyoFinished, tennisList]);

    return (
        <div className="searchTennisContainer">
            <HeaderLanguageSwitch />
            <Layout>
                <Header style={{ background: '#fff', padding: 0 }}>
                    <Menu mode="horizontal" defaultSelectedKeys={['home']}>
                        <Menu.Item
                            key="home"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '25%',
                            }}
                        >
                            <span>{t('searchTennis.title')}</span>
                            {(loading || tokyoLoading) && (
                                <span style={{ marginLeft: 16 }}>
                                    <Loading />
                                </span>
                            )}
                        </Menu.Item>
                    </Menu>
                    <DatePicker
                        allowClear
                        placeholder={t('searchTennis.placeholderStart')}
                        value={selectedStart ? dayjs(selectedStart, 'YYYY-MM-DD') : undefined}
                        format="YYYY-MM-DD"
                        onChange={(date, dateString) => {
                            const ds = Array.isArray(dateString) ? dateString[0] : dateString;
                            setSelectedStart(ds || null);
                            if (selectedEnd && ds && ds > selectedEnd) setSelectedEnd(null);
                        }}
                        className='date-picker-start'
                        style={{ marginRight: 8 }}
                        disabledDate={(current) => {
                            const d = toDate(current);
                            return !d ? false : d < todayStart;
                        }}
                    />
                    <DatePicker
                        allowClear
                        placeholder={t('searchTennis.placeholderEnd')}
                        value={selectedEnd ? dayjs(selectedEnd, 'YYYY-MM-DD') : undefined}
                        format="YYYY-MM-DD"
                        onChange={(date, dateString) => {
                            const ds = Array.isArray(dateString) ? dateString[0] : dateString;
                            const end = ds || null;
                            setSelectedEnd(end);
                            if (end) {
                                setSelectedStart(prev => {
                                    if (prev) return prev;
                                    return todayStr;
                                });
                            }
                        }}
                        className='date-picker-end'
                        disabledDate={(current) => {
                            const d = toDate(current);
                            if (!d) return false;
                            if (d < todayStart) return true;
                            if (selectedStart) {
                                const startDate = new Date(selectedStart + 'T00:00:00');
                                return d < startDate;
                            }
                            return false;
                        }}
                    />
                    <Select
                        defaultValue="all"
                        className="select-filter"
                        onChange={(value) => setFilter(value)}
                    >
                        <Option value="all">{t('searchTennis.filter.all')}</Option>
                        <Option value="weekend">{t('searchTennis.filter.weekend')}</Option>
                        <Option value="non-weekend">{t('searchTennis.filter.nonWeekend')}</Option>
                    </Select>
                    <div className="user-info">
                        <TennisUser />
                    </div>
                    <Tooltip
                        title={
                            <div
                                onMouseEnter={() => handleTooltipOverlayHover()}
                                // 可选：当鼠标移出 tooltip 内容时不做额外处理（只在 enter 时触发 5s 禁用）
                                onMouseLeave={() => { }}
                                style={{ display: 'inline-block' }}
                            >
                                {t('searchTennis.hintViewAvailable') || '点击此处查看可购买的场地'}
                            </div>
                        }
                        placement="bottom"
                        align={{ offset: [0, 0] }}
                        visible={!isHovered && !isTooltipDisabled}
                    >
                        <div
                            className="auction"
                            onClick={() => navigate('/auction')}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
                            aria-label={t('searchTennis.hintViewAvailable')}
                        >
                        </div>
                    </Tooltip>
                </Header>
            </Layout>
            {filteredTennisList.length > 0 ? (
                <List
                    grid={{ gutter: 16, column: 2 }}
                    dataSource={filteredTennisList}
                    renderItem={item => {
                        const district = getDistrictByName(item.name);
                        // 判断链接
                        let link = 'https://k5.p-kashikan.jp/adachi-ku/index.php';
                        if (buildingList.some(b => b.name === item.name)) {
                            link = 'https://rsv.shisetsu.city.katsushika.lg.jp/katsushika/web/menu.jsp';
                        } else if (tokyobuildingList.some(b => b.name === item.name)) {
                            link = 'https://kouen.sports.metro.tokyo.lg.jp/web/index.jsp';
                        } else if (matsudoBuildingList.some(b => b.name === item.name)) {
                            link = 'https://yoyaku.city.matsudo.chiba.jp/web/index.jsp#free-search';
                        } else if (edogawaBuildingList.some(b => b.name === item.name)) {
                            link = 'https://www.shisetsuyoyaku.city.edogawa.tokyo.jp/user/Home#divSearch';
                        }
                        return (
                            <List.Item>
                                <Card
                                    title={
                                        <a
                                            href={link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ textDecoration: 'none', color: '#1976d2' }}
                                        >
                                            {item.name}
                                        </a>
                                    }
                                    extra={
                                        <span style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                            <Tag color="blue">{district}</Tag>
                                            {Object.keys(item.days).some(date => isWeekendOrHoliday(date)) ? (
                                                <Tag color="green">{t('searchTennis.filter.weekend')}</Tag>
                                            ) : (
                                                <Tag color="grey">{t('searchTennis.filter.nonWeekend')}</Tag>
                                            )}
                                        </span>
                                    }
                                >
                                    {(() => {
                                        const allDates = Object.keys(item.days || {});
                                        // 计算要显示的日期（若未选择则显示全部）
                                        let showDates = allDates;
                                        if (selectedStart && selectedEnd) {
                                            showDates = allDates.filter(d => d >= selectedStart && d <= selectedEnd);
                                            console.log('筛选日期范围:', selectedStart, selectedEnd, showDates);
                                        } else if (selectedStart) {
                                            showDates = allDates.filter(d => d === selectedStart);
                                            console.log('筛选日期:', selectedStart, showDates);
                                        } else if (selectedEnd) {
                                            showDates = allDates.filter(d => d === selectedEnd);
                                            console.log('筛选日期:', selectedEnd, showDates);
                                        }
                                        // 按日期排序并渲染
                                        return showDates.sort().map(date => {
                                            const times = item.days[date] || [];
                                            const isSpecial = isWeekendOrHoliday(date);
                                            const sortedTimes = [...times].sort((a, b) => {
                                                const getStartHour = (str: string) => {
                                                    const match = str.match(/^(\d{1,2}):/);
                                                    return match ? parseInt(match[1], 10) : 0;
                                                };
                                                return getStartHour(a) - getStartHour(b);
                                            });
                                            return (
                                                <div key={date} style={{ marginBottom: 8 }}>
                                                    <strong style={isSpecial ? { color: 'green' } : {}}>{date}：</strong>
                                                    <span style={isSpecial ? { color: 'green' } : {}}>
                                                        {sortedTimes.join('、')}
                                                    </span>
                                                </div>
                                            );
                                        });
                                    })()}
                                </Card>
                            </List.Item>
                        );
                    }}
                />
            ) : (
                <p>
                    {t('searchTennis.loading')}
                    <span className="dots">{dots}</span>
                </p>
            )}
        </div>
    );
}